import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSColumn, NSCopy, NSLabel, NSLineText, NSRow, URLFormatter } from "namirasoft-site-react";
import { Component } from "react";
import { StorageRouterProps } from "../StorageRouterProps";

export interface StorageConnectProps extends NSARouterMakerResult, StorageRouterProps
{
    storage_id: string;
    host?: string;
}

interface ConnectionField
{
    title: string;
    description: string;
    is_url?: boolean;
}

interface ConnectionSection
{
    title: string;
    fields: ConnectionField[];
}

export default class StorageConnect extends Component<StorageConnectProps>
{
    override render()
    {
        let host = this.props.host ?? "storage.namirasoft.com";
        let id = this.props.storage_id;

        let sections: ConnectionSection[] = [
            {
                title: "Web UI",
                fields: [
                    { title: "URL", description: `https://${host}/${id}`, is_url: true },
                    { title: "Host", description: host },
                    { title: "Path", description: `/${id}` },
                ]
            },
            {
                title: "SFTP",
                fields: [
                    { title: "URL", description: `sftp://sftp.${host}:2022`, is_url: true },
                    { title: "Host", description: `sftp.${host}` },
                    { title: "Port", description: "2022" },
                ]
            },
            {
                title: "WebDAV",
                fields: [
                    { title: "URL", description: `https://webdab.${host}/${id}`, is_url: true },
                    { title: "Host", description: `webdab.${host}` },
                    { title: "Path", description: `/webdav/${id}` },
                ]
            },
            {
                title: "HTTP",
                fields: [
                    { title: "URL", description: `https://http.${host}/${id}`, is_url: true },
                    { title: "Host", description: `http.${host}` },
                    { title: "Path", description: `/${id}` },
                ]
            },
            {
                title: "S3",
                fields: [
                    { title: "URL", description: `https://s3.${host}/${id}`, is_url: true },
                    { title: "Host", description: `s3.${host}` },
                    { title: "Path", description: `/${id}` },
                ]
            },
        ];

        let url_formatter = new URLFormatter();

        return (
            <NSColumn style={{ width: "100%", marginTop: 16, gap: 8 }}>
                {sections.map((section) => (
                    <NSColumn key={section.title} style={{ width: "100%", gap: 8 }}>
                        <NSLineText title={section.title} />
                        <NSRow style={{ width: "100%", gap: 24, flexWrap: "wrap", justifyContent: "flex-start" }}>
                            {section.fields.map((field) => (
                                <NSLabel key={field.title} title={field.title}>
                                    <NSCopy value={field.description}>
                                        {
                                            field.is_url
                                                ? url_formatter.format(field.description, null as any, null as any, false)
                                                : <span>{field.description}</span>
                                        }
                                    </NSCopy>
                                </NSLabel>
                            ))}
                        </NSRow>
                    </NSColumn>
                ))}
            </NSColumn>
        );
    }
}